var _style, _path, _path2, _g, _g2, _line, _line2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolleyball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke-width:25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M912,512c0,79.4-23.2,153.5-63.1,215.7C777.8,838.6,653.5,912,512,912c-220.9,0-400-179.1-400-400 c0-220.9,179.1-400,400-400c141.5,0,265.8,73.4,336.9,184.3C888.8,358.5,912,432.6,912,512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M848.9,296.3H427c-39.9,62.2-63.1,136.3-63.1,215.7c0,79.4,23.2,153.5,63.1,215.7h421.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427,296.3c0,0-50-104.9-154.3-104.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.4,296.3c0,0-26.3-138.9-176.3-173.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M731.7,296.3c0,0-15.5-131.7-159.8-179.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427,727.4c0,0-50,104.9-154.3,104.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.4,728.4c0,0-26.3,137.9-176.3,172.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M731.7,728.4c0,0-15.5,130.7-159.8,178.8"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 387,
    y1: 426,
    x2: 898.9,
    y2: 426
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 368.5,
    y1: 572.4,
    x2: 898.9,
    y2: 572.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.5,797.2c0,0-107.7-113.3-108.4-278.1c-0.8-194.6,107.4-293.7,107.4-293.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.8,830c0,0-131.7-104.8-131.8-317.5c-0.1-210.7,138.9-317.5,138.9-317.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyball);
export default __webpack_public_path__ + "static/media/Volleyball.6b4ad9c3.svg";
export { ForwardRef as ReactComponent };